// extracted by mini-css-extract-plugin
module.exports = {"dotContainer":"_2zD2r","isActive":"_515hG","dot":"eQjvX"};